// VOLTECH POWER SOLUTIONS — site-wide constants

export const COMPANY = {
  name: "VOLTECH POWER SOLUTIONS",
  short: "VPS",
  tagline: "Achieve your Goals",
  gstin: "36AATFV5997N1ZQ",
  email: "info@voltechpowersolutions.in",
  address: "BN Reddy Nagar, Cherlapally, Hyderabad — 500051",
  city: "Hyderabad, Telangana, India",
  phoneSales: "9398422625",
  phoneService: "7672067048",
  whatsapp: "919398422625",
  whatsappChannel:
    "https://whatsapp.com/channel/0029VaUXQCoCXC3RPMZQpB28",
  indiamart: "https://www.indiamart.com/voltechpowersolutions/",
  playStore:
    "https://play.google.com/store/apps/details?id=app.emergent.batteryservicehub2f4782948",
  mapsUrl: "https://maps.app.goo.gl/2h8HrDFiqRkgU7eL8",
  mapsEmbed:
    "https://www.google.com/maps?q=VOLTECH+POWER+SOLUTIONS,+B+N+Reddy+Nagar,+Cherlapalli,+Hyderabad&output=embed",
  logo: "https://customer-assets.emergentagent.com/job_86e8291b-4621-4191-9355-412a5a7abfe4/artifacts/h0kzwlik_1656007966754%20%281%29.png",
};

export const CORE_PILLARS = [
  {
    id: "lithium",
    title: "Lithium Batteries",
    short: "Li-ion / LiFePO4",
    description:
      "End-to-end manufacturing and servicing of lithium-ion & LiFePO4 battery packs for EVs, telecom, traffic signals, weighing scales, and custom industrial loads.",
    image:
      "https://images.unsplash.com/photo-1742899273038-67ff67477663?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHw0fHxsaXRoaXVtJTIwYmF0dGVyeSUyMGluZHVzdHJpYWx8ZW58MHx8fHwxNzgxNzcwMzM3fDA&ixlib=rb-4.1.0&q=85",
    spec: "12V — 96V · 7Ah — 500Ah",
  },
  {
    id: "solar",
    title: "Solar Street Lights",
    short: "All-in-one solar",
    description:
      "Turnkey design, fabrication and installation of integrated solar LED street lights, high-mast poles and rural lighting solutions powered by LiFePO4.",
    image:
      "https://images.pexels.com/photos/29294301/pexels-photo-29294301.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    spec: "20W — 200W · IP66",
  },
  {
    id: "ev",
    title: "Electric Vehicles",
    short: "2W / 3W EV",
    description:
      "Sale, assembling and service of 2-wheeler & 3-wheeler electric vehicles plus customised drivetrain battery packs with intelligent BMS.",
    image:
      "https://images.unsplash.com/photo-1707758283398-7df21adba23a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHw0fHxlbGVjdHJpYyUyMHZlaGljbGUlMjBuaWdodHxlbnwwfHx8fDE3ODE3NzAzMzd8MA&ixlib=rb-4.1.0&q=85",
    spec: "48V — 72V drivetrains",
  },
  {
    id: "csr",
    title: "CSR Projects",
    short: "Energy for community",
    description:
      "Partner with us on CSR-led clean-energy initiatives — solar lighting for schools, villages, public spaces and skilling programs for students.",
    image:
      "https://images.pexels.com/photos/9159675/pexels-photo-9159675.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    spec: "End-to-end execution",
  },
];

export const SERVICES = [
  { name: "Li-ion Battery Manufacturing & Service", category: "Batteries" },
  { name: "Customised Battery Packs", category: "Batteries" },
  { name: "EV Battery Manufacturing", category: "Batteries" },
  { name: "EV Battery Services", category: "Batteries" },
  { name: "2W & 3W EV Battery Mfg & Service", category: "Batteries" },
  { name: "Traffic Signal Batteries", category: "Batteries" },
  { name: "Weighing Scale Batteries", category: "Batteries" },
  { name: "Robotics Batteries", category: "Batteries" },
  { name: "Market Light Batteries", category: "Batteries" },
  { name: "Battery Raw Material Supply", category: "Batteries" },
  { name: "Solar Street Lights", category: "Solar & Lighting" },
  { name: "Pole Fabrications", category: "Solar & Lighting" },
  { name: "Inverters", category: "Power Systems" },
  { name: "Electric Vehicle Sale & Assembling", category: "EV" },
  { name: "CSR Projects", category: "Community" },
  { name: "College Student Projects", category: "Community" },
];

export const CAPABILITIES = [
  {
    code: "01",
    title: "Cell to Pack",
    body: "In-house spot welding, BMS programming, balancing, IP-rated enclosure assembly — fully traceable.",
  },
  {
    code: "02",
    title: "Custom Engineering",
    body: "Custom voltage, capacity, form-factor and connector specs for OEMs, EV builders and industrial loads.",
  },
  {
    code: "03",
    title: "Solar EPC",
    body: "Site survey, structural design, in-house pole fabrication, installation and AMC for solar street lights.",
  },
  {
    code: "04",
    title: "EV Assembling",
    body: "2-wheeler & 3-wheeler EV assembling, drivetrain integration, controller tuning, road-readiness QC.",
  },
  {
    code: "05",
    title: "CSR Delivery",
    body: "Turnkey CSR execution with documentation, beneficiary reports and post-installation maintenance.",
  },
  {
    code: "06",
    title: "Student Projects",
    body: "Supply, mentoring and co-build for engineering & polytechnic student energy projects.",
  },
];

export const TRUST_MARQUEE = [
  "LITHIUM BATTERY MANUFACTURING",
  "PAN-INDIA DELIVERY",
  "CUSTOM BATTERY PACK DESIGN",
  "SOLAR STREET LIGHT EPC",
  "EV ASSEMBLING & SERVICE",
  "CSR EXECUTION PARTNER",
  "GSTIN 36AATFV5997N1ZQ",
  "MADE IN HYDERABAD · INDIA",
];
